<h2 *ngIf="data.title" mat-dialog-title>{{ data.title | transloco }}</h2>

<mat-dialog-content *ngIf="data.content">{{ data.content }}</mat-dialog-content>

<mat-dialog-actions align="end">
  <ng-container *ngIf="data.selectButton === 'no'">
    <button mat-button mat-dialog-close cdkFocusInitial>{{ data.no | transloco }}</button>
    &nbsp;&nbsp;
    <button mat-flat-button [color]="data.yesButtonColor" [mat-dialog-close]="true">{{ data.yes | transloco }}</button>
  </ng-container>

  <ng-container *ngIf="data.selectButton === 'yes'">
    <button mat-button mat-dialog-close>{{ data.no }}</button>
    &nbsp;&nbsp;
    <button mat-flat-button [color]="data.yesButtonColor" [mat-dialog-close]="true" cdkFocusInitial>
      {{ data.yes | transloco }}
    </button>
  </ng-container>
</mat-dialog-actions>
